import React from "react";
import { createPortal } from "react-dom";
import { useMutation } from "@apollo/client";

import "./OrdersDateChangedBanner.css";
import { Icon } from "../Icon/Icon";
import { DISMISS_CART_BANNER } from "../../GraphQL/Mutations/dismissCartBanner.mutation";

export const OrdersDateChangedBanner = ({ show, reason, cartId }) => {
  const root = document.getElementById("order_date_changed");
  const [dismissBanner] = useMutation(DISMISS_CART_BANNER);

  const handleDismiss = () => {
    if (cartId) {
      dismissBanner({ variables: { cartId } });
    }
  };

  return show
    ? createPortal(
        <div className="OrdersDateChangedBanner">
          <div className="OrdersDateChangedBanner__title">
            <div className="OrdersDateChangedBanner__icon">
              <Icon name="notification" width={15} />
            </div>
            <div className="OrdersDateChangedBanner__title-text">
              {reason === 'holiday' && 'Bemærk: Tidspunktet for din kommende bestilling er ændret på grund af helligdag'}
              {reason === 'weekend' && 'Bemærk: Tidspunktet for din kommende bestilling er ændret på grund af weekend'}
              {reason === 'past_date' && 'Bemærk: Tidspunktet for din kommende bestilling er ændret da den oprindelige dato er passeret'}
              {!reason && 'Bemærk: Tidspunktet for din kommende bestilling er ændret'}
            </div>
            <button 
              className="OrdersDateChangedBanner__dismiss" 
              onClick={handleDismiss}
              aria-label="Luk besked"
            >
              ×
            </button>
          </div>
        </div>,
        root
      )
    : null;
};
